import { useEffect, useState } from 'react'
import { DKLabel, showToast, TOAST_TYPE, DKButton, DKIcons, DKIcon, DKInput, INPUT_VIEW_DIRECTION, showLoader, removeLoader, DKCheckMark, DKExpandableWrapper, DKLine, DKRadioButton, Toggle } from "deskera-ui-library";
import Table from '../../services/table';
import { useDispatch } from 'react-redux';
import Utility from '../../utility/Utility';
import { INPUT_TYPE } from '../../constants/Constant';



const AddCustomFieldPopUp = (props) => {

    const initialState = {
        "type": "text",
        "isMandatory": false,
        "possibleValues": [],
        "defaultValue": [],
        "isActive": true,
        "maxLength": "",
        "decimalPrecision": ""
    }

    const dispatch = useDispatch();

    const [dropDownMenu, setDropDownMenu] = useState([]);
    const [showFileds, setShowFileds] = useState({
        isTextFieldSelected: true,
        isNumberFieldSelected: false,
        isDropDownSelected: false,
        isDateFieldSelected: false
    });

    const [dropDownError, setDropDownError] = useState([false, false])
    const [errorField, setErrorField] = useState({})
    const [customField, setCustomField] = useState({
        ...initialState,
        "name": "",
        "mappedWith": [
            "employee_details"
        ],
    })
    const isEdit = props?.customFieldData?.id ? true : false;
    const [customFieldData, setCustomFieldData] = useState(props.customFieldData)

    useEffect(() => {
        setDropDownMenu([
            { list: "", isChecked: true, isNewOptionAdded: true },
            { list: "", isChecked: false, isNewOptionAdded: true }
        ]);

        if(isEdit) {
            setDefaultValuesToForm(customFieldData);
        }

        setErrorField({
            "fieldName": false,
            "decimalPrecision": false,
            "length": false,
            "maxLength": { hasError: false, errMsg: "" },
            "decimalField": { hasError: false, errMsg: "" },
            "nameField": { hasError: false, errMsg: "" }
        })
        
    }, []);

    const setDefaultValuesToForm = (dataToFillForm) => {
        setCustomField({
            ...customField,
            ...dataToFillForm
        });

        setShowFileds({
            isTextFieldSelected: dataToFillForm.type === INPUT_TYPE.TEXT,
            isNumberFieldSelected: dataToFillForm.type === INPUT_TYPE.NUMBER,
            isDropDownSelected: dataToFillForm.type === "multiselect",
            isDateFieldSelected: dataToFillForm.type === INPUT_TYPE.DATE
        });

        const dropDownList = dataToFillForm.possibleValues?.map(value=>{
            return { 
                list: value,
                isChecked: dataToFillForm.defaultValue?.indexOf(value) !== -1 
            }
        });

        if (dropDownList?.length > 0) {
            setDropDownMenu(dropDownList);
        }
    }
    const onChangeOfDefault = (index) => {
        let menuOption = dropDownMenu.slice()
        menuOption.forEach(obj => {
            obj.isChecked = false
        })
        menuOption[index].isChecked = !menuOption[index].isChecked
        setDropDownMenu(menuOption)

    }

    const onOptionDelete = (index) => {
        if (dropDownMenu.length == 1) {
            showToast('Option should contain atleast 1 value, failed to delete', TOAST_TYPE.WARNING);
            return
        }
        let optionError = dropDownError.slice()
        optionError.splice(index, 1)
        setDropDownError(optionError)
        let menuOption = dropDownMenu.slice()
        menuOption.splice(index, 1);
        if (dropDownMenu[index].isChecked) {
            menuOption[0].isChecked = true
        }
        setDropDownMenu(menuOption)
    }

    const DropDownValueChange = (index, value) => {
        dropDownMenu[index].list = value
        setDropDownMenu(dropDownMenu)
        if (value.trim() === "") {
            let menuOption = dropDownError.slice()
            menuOption[index] = true
            setDropDownError(menuOption)
        }
    }

    const showDropDownMenu = () => {
        let a
        if (dropDownMenu) {
            a = dropDownMenu.map((option, index) => {
                let fieldNumb = index + 1
                return (
                    <div className="parent-width row">
                        <div className="col-sm mb-l" style={{ width: "115%" }}>
                            <DKInput
                                value={dropDownMenu[index].list}
                                title={"Dropdown value " + fieldNumb}
                                canValidate={dropDownError[index]}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={isEdit ? !option.isNewOptionAdded : false}
                                onChange={(value) => {
                                    DropDownValueChange(index, value)
                                }
                                }
                            />
                        </div>
                        <div
                            className={`row  ml-xxl cursor-hand`}
                            onClick={() => {
                                
                                onChangeOfDefault(index)
                            }}
                        >
                            <DKCheckMark  isSelected={dropDownMenu[index].isChecked} color={"bg-app"} /><DKLabel className="ml-s" text={"Set as default"} />
                        </div>
                        <div className={`${(isEdit ? !option.isNewOptionAdded : false) ? "cursor-not-allowed":"cursor-hand" }`} onClick={() => {  
                            if(isEdit ? !option.isNewOptionAdded : false) {
                                return
                            }
                            onOptionDelete(index)
                        }} 
                        style={{ opacity: "0.6" }} >
                            <DKIcon src={DKIcons.ic_delete} className="ic-s-2 ml-s mr-xl " style={{ opacity: 0.8 }} />
                        </div>

                    </div>
                )
            })
        }
        return a
    }

    const onAddNewOption = () => {
        let menuOption = dropDownMenu.slice()
        menuOption.push({ list: "", isChecked: menuOption.length > 0 ? false : true,isNewOptionAdded:true })
        let optionError = dropDownError.slice()
        optionError.push(false)
        setDropDownError(optionError)
        setDropDownMenu(menuOption)
    }

    const initializeState = (type) => {
        const field = { ...customField }
        field.defaultValue = []
        field.type = type

        setCustomField(field);

        setShowFileds({
            isTextFieldSelected: type === "text" ? true : false,
            isNumberFieldSelected: type === "number" ? true : false,
            isDropDownSelected: type === "multiselect" ? true : false,
            isDateFieldSelected: type === "date" ? true : false,
        })
    }

    const saveCustomFields = () => {
        if (customField.type === "multiselect") {
            let menuOption = dropDownMenu.slice();
            let errorOption = dropDownError.slice();
            let isFormInValid = false;
            let option = [];
            let defaultvalue = "";

            menuOption.forEach((optionObj, index) => {
                option.push(optionObj.list.trim())
                if (optionObj.isChecked) {
                    defaultvalue = optionObj.list.trim()
                }
                if (optionObj.list.trim() === "") {
                    errorOption[index] = true
                    isFormInValid = true
                }
            });

            if (isFormInValid) {
                setDropDownError(errorOption)
            }
            if (customField.name.trim() === "") {
                setErrorField({ ...errorField, fieldName: true })
                return
            }
            if (isFormInValid) {
                return
            }
            
            customField.possibleValues = option
            customField.defaultValue = [defaultvalue]
            customField.maxLength = 0
            customField.decimalPrecision = 0
        } else if (customField.type === "text") {
            customField.maxLength = customField.maxLength.toString()
            if (customField.name.trim() === "" || Utility.isEmpty(customField.maxLength.trim())) {
                setErrorField({ ...errorField, fieldName: true, length: Utility.isEmpty(customField.maxLength.trim()) ? true : false })
                return
            }
            customField.defaultValue = customField.defaultValue.map(defaultValue=> defaultValue.trim())
            if (customField.defaultValue[0] && customField.defaultValue[0].length > parseInt(customField.maxLength)) {
                showToast('Custom field Default Value exceeds the Max Length ', TOAST_TYPE.FAILURE);
                return
            }
            
            if (isEdit && !Utility.isEmpty(props.customFieldData.maxLength) && !Utility.isEmpty(customField.maxLength) && parseInt(props.customFieldData.maxLength) > parseInt(customField.maxLength)) {
                showToast('Max length cannot be less than previous set', TOAST_TYPE.FAILURE);
                return
            }

            customField.maxLength = customField.maxLength.toString().trim() === "" ? 0 : parseInt(customField.maxLength)
            customField.decimalPrecision = 0;
            customField.possibleValues = [];
        } else if (customField.type === "number") {
            customField.decimalPrecision = customField.decimalPrecision.toString()
            if (customField.decimalPrecision.trim() === "" || customField.name.trim() === "") {
                setErrorField({ fieldName: customField.name.trim() === "" ? true : false, decimalPrecision: customField.maxLength.trim() === "" ? true : false })
                return
            }
            customField.defaultValue = customField.defaultValue.map(defaultValue=> defaultValue.trim())
            if (customField.decimalPrecision.toString().trim() !== "" && customField.defaultValue[0]) {
                let maxLength = parseInt(customField.decimalPrecision.toString())
                const myArr = customField.defaultValue[0].split(".")
                if (myArr.length > 1 && maxLength < myArr[1].toString().length) {
                    showToast('Custom field default value exceeds the decimal precision ', TOAST_TYPE.FAILURE);
                    return
                }

            }
            
            if (isEdit && !Utility.isEmpty(props.customFieldData.decimalPrecision) && !Utility.isEmpty(customField.decimalPrecision) && parseInt(props.customFieldData.decimalPrecision) > parseInt(customField.decimalPrecision)) {
                showToast('Decimal precision cannot be less than previous set', TOAST_TYPE.FAILURE);
                return
            }

            customField.decimalPrecision = customField.decimalPrecision.toString().trim() === "" ? 0 : parseInt(customField.decimalPrecision)
            customField.maxLength = 0;
            customField.possibleValues = [];
        } else if (customField.type === "date") {
            if (customField.name.trim() === "") {
                setErrorField({ ...errorField, fieldName: true })
                return
            }
            customField.decimalPrecision = 0;
            customField.maxLength = 0;
            customField.possibleValues = [];
        }
        
        save()
    }

    const save = async () => {

        try {
            let payload = {
                ...customField
            }
            if(isEdit) {
                delete payload.error
                delete payload.displayIn
                delete payload.selected
                delete payload.preference

                showLoader(`Updating custom field`);
                Table.updateCustomField(payload).then((data) => {
                    removeLoader()
                    if (data?.error && data.error.errorCode === "CF_1001") {
                        showToast('Custom field default value exceeds the maxlength', TOAST_TYPE.FAILURE);
                        return
                    }

                    if (data?.error && data.error.errorCode === "CF_1003") {
                        showToast('Cannot update custom field as it is already used in some of the modules', TOAST_TYPE.FAILURE);
                        return
                    }
    
                    if (data?.error && data.error.errorCode === "CF_1004") {
                        showToast(data.error.details, TOAST_TYPE.FAILURE);
                        return
                    }
    
                    showToast("Record updated Successfully", TOAST_TYPE.SUCCESS);
                    props.loadCustomFields({}).then(props.onClose())
                },error=>{
                    removeLoader()
                    showToast('Error while updating custom field ', TOAST_TYPE.FAILURE);
                })
            } else {
                showLoader(`Saving custom field`);
                Table.postCustomField(payload).then((data) => {
                    removeLoader()
                    if (data?.error && data.error.errorCode === "CF_1001") {
                        showToast('Custom field default value exceeds the maxlength ', TOAST_TYPE.FAILURE);
                        return
                    }
    
                    if (data?.error && data.error.errorCode === "CF_1004") {
                        showToast(data.error.details, TOAST_TYPE.FAILURE);
                        return
                    }
    
                    showToast("Record inserted Successfully", TOAST_TYPE.SUCCESS);
                    props.loadCustomFields({}).then(props.onClose())
                },error=>{
                    removeLoader()
                    showToast('Error inserting custom field ', TOAST_TYPE.FAILURE);
                })
            }
        } catch (err) {
            removeLoader()
            showToast('Error inserting custom field ', TOAST_TYPE.FAILURE);
        }
    }

    const onMaxLengthChange = (value) => {
        if (Utility.isEmpty(value.toString().trim())) {
            value = value.toString().trim();
            setErrorField({ ...errorField, length: true, maxLength: { hasError: true, errMsg: "Enter a valid value" } })
        } else if (!Utility.isEmpty(value.toString().trim()) && parseInt(value) === 0) {
            setErrorField({ ...errorField, length: true, maxLength: { hasError: true, errMsg: "Max length should be greater than or equal to 0" } })
        } else if (!Utility.isEmpty(value.toString().trim()) && parseInt(value) > 50) {
            setErrorField({ ...errorField, length: true, maxLength: { hasError: true, errMsg: "Max length should be less than or equal to 50" } })
        } else if (isEdit && !Utility.isEmpty(props.customFieldData.maxLength) && !Utility.isEmpty(value) && parseInt(props.customFieldData.maxLength) > parseInt(value)) {
            setErrorField({ ...errorField, length: true, maxLength: { hasError: true, errMsg: "Max length should be greater than or equal to previous set" } })
        } else {
            setErrorField({ ...errorField, length: false, maxLength: { hasError: false, errMsg: "" } })
        }

        setCustomField({ ...customField, maxLength: value });
    }

    const onCheckMarkChange = (fieldName) => {
        const mappedWith = customField?.mappedWith;
        const index = mappedWith.findIndex(m => m === fieldName);
        if (index != -1) {
            mappedWith.splice(index, 1);
        } else {
            mappedWith.push(fieldName);
        }
        setCustomField({ ...customField, mappedWith: mappedWith });
    }

    const getBgColor = () =>{
        return isEdit ? "bg-gray" : "bg-app";
    }

    const onMandetoryCheck = () => {
      setCustomField({
        ...customField,
        isMandatory: !customField.isMandatory,
      });
    };

    return (
        <div className="popup-window" style={{ maxWidth: 600 }}>
            <div className="row">
                <DKLabel text={isEdit ? "Edit Custom Field": "Create Custom Field"} className="fs-m fw-m align-self-center width-80" />
                <div className="row-reverse ">
                    <DKButton
                        title={isEdit ? "Update":"Save"}
                        className="border-m ml-r bg-app text-white"
                        onClick={() => saveCustomFields()}
                    />
                    <DKButton
                        title="Cancel"
                        className="g-gray1 border-m"
                        onClick={(event) => {
                            props.onClose();
                        }}
                    />


                </div>

            </div>
            <div className="parent-width custom-scroll scrollbar-thin" style={{ overflowY: "auto", overflowX: "hidden" }}>
                <div className="p-s">


                    <div className="column row mb-l" style={{ width: "47%" }}>
                        <DKInput
                            value={customField.name}
                            title="Field Name"
                            canValidate={errorField.fieldName}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            onChange={(value) => {
                                if (value === "") {
                                    setErrorField({ ...errorField, fieldName: true })
                                }
                                customField.name = value
                            }
                            }
                        />
                    </div>
                    <div className="row align-items-start">
                        <div classname="row display-block" style={{ width: "50%" }}>
                            <div className="row">
                            <DKRadioButton
                                isSelected={showFileds.isTextFieldSelected}
                                color={getBgColor()}
                                onClick={() => {
                                    initializeState("text")
                                }}
                            />
                            <DKLabel
                                    className="fs-m pl-s pr-s fw-m"
                                    text="Text Box"
                                />
                            </div>
                            <DKLabel
                                className="fs-m pl-xs pr-s ml-xl"
                                text="(Set character limit)"
                            />
                        </div>

                        

                        <div classname="row display-block" style={{ width: "50%" }}>
                        <div className="row">
                            <DKRadioButton
                                isSelected={showFileds.isDropDownSelected}
                                color={getBgColor()}
                                onClick={() => {
                                    initializeState("multiselect")
                                }}
                            />
                            <DKLabel
                                    className="fs-m pl-s pr-s fw-m"
                                    text="Multiple Selection Dropdown Menu"
                                />
                            </div>
                            <DKLabel
                                className="fs-m pl-xs pr-s ml-xl"
                                text="User can choose 1 options from multiple choices"
                            />
                        </div>
                    </div>


                    <div className="row align-items-start">
                        <div className="row">
                            <div classname="row display-block">
                                <div className="row">
                                    <DKRadioButton
                                        isSelected={showFileds.isNumberFieldSelected}
                                        color="bg-app"
                                        onClick={() => {
                                            initializeState("number")
                                        }}
                                    />
                                    <DKLabel
                                        className="fs-m pl-s pr-s fw-m"
                                        text="Numbers"
                                    />
                                </div>
                                <DKLabel
                                    className="fs-m pl-xs pr-s ml-xl"
                                    text="User can set decimal limit"
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div classname="row display-block">
                                <div className="row">
                                    <DKRadioButton
                                        isSelected={showFileds.isDateFieldSelected}
                                        color="bg-app"
                                        onClick={() => {
                                            initializeState("date")
                                        }}
                                    />
                                    <DKLabel
                                        className="fs-m pl-s pr-s fw-m"
                                        text="Date"
                                    />
                                </div>
                                <DKLabel
                                    className="fs-m pl-xs pr-s ml-xl"
                                    text="Calendar"
                                />
                            </div>
                        </div>
                    </div>
                    


                    {showFileds.isTextFieldSelected && (
                        <div className="parent-width mt-xxl" style={{ display: 'flex' }}>
                            <div style={{ width: "48%" }}>
                                <DKInput
                                    value={customField.maxLength}
                                    title="Max Length"
                                    className="mr-l"
                                    type="number"
                                    required={true}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    canValidate={errorField?.maxLength?.hasError}
                                    readOnly={false}
                                    onChange={(value) => {
                                        onMaxLengthChange(value)
                                    }}
                                />
                            </div>
                            <div style={{ width: "48%" }}>
                                <DKInput
                                    value={customField.defaultValue[0]}
                                    title="Default value"
                                    className="ml-l"
                                    required={false}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    readOnly={false}
                                    onChange={(value) => {
                                        if (value === "") {
                                            setErrorField({ ...errorField, value: true })
                                        }

                                        setCustomField({
                                            ...customField,
                                            defaultValue: [value]
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {showFileds.isDropDownSelected && (
                        <div className="parent-width mt-xxl">
                            {showDropDownMenu()}

                            <div id="" className="d-flex m-v-s ">
                                <DKButton
                                    title="Add New Option"
                                    className={`border-m text-white bg-app`  }
                                    onClick={(event) => {
                                        onAddNewOption(event);
                                    }}
                                />

                            </div>
                        </div>
                    )}

                    {showFileds.isNumberFieldSelected && (
                        <div className="parent-width mt-xxl" style={{ display: 'flex' }}>
                            <DKInput
                                value={customField.decimalPrecision}
                                title="Decimal Precision"
                                className="mr-l"
                                type="number"
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                canValidate={errorField.decimalPrecision}
                                readOnly={false}
                                onChange={(value) => {
                                    if (value === "") {
                                        setErrorField({ ...errorField, decimalPrecision: true })
                                    }
                                    customField.decimalPrecision = value
                                }
                                }
                            />
                            <DKInput
                                value={customField.defaultValue[0]}
                                title="Default value"
                                className="ml-l"
                                required={false}
                                type="number"
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                readOnly={false}
                                onChange={(value) => {
                                    setCustomField({
                                        ...customField,
                                        defaultValue: [value]
                                    });
                                }}
                            />
                        </div>
                    )}
                    {false && <div
                        className="d-flex align-items-center mt-xl"
                        // style={{ pointerEvents: isEdit ? "none" : "initial" }}
                    >
                        <Toggle
                            className="border-n"
                            isOn={customField["isActive"]}
                            // color={getBgColor()}
                            onChange={() => {
                                setCustomField({
                                    ...customField,
                                    isActive: !customField.isActive
                                })
                            }}
                        />
                        <DKLabel className="ml-m" text={customField.isActive ? 'Active': 'Inactive'} />
                    </div>}
                    {
                        <div className="row pt-xl">
                            <DKCheckMark className="cursor-hand" disabled={false} isSelected={customField.isMandatory} color={"bg-app"} onClick={() => onMandetoryCheck()}/>
                            <DKLabel className="ml-s" text={"Is Mandatory"} />
                        </div>
                    }
                    <div className="mt-xl parent-width bg-white border-radius-s card-shadow-form">
                        <DKExpandableWrapper
                            id="1"
                            title={`<div><span>Modules</span> <span class="fs-m fw-r">(${customField?.mappedWith.length} selected)</span></div>`}
                            className="collapsable"
                            expanded={true}
                            headerStyle={{ padding: "20px" }}
                            onClick={(expanded) => {}}
                        >
                            <DKLine className="bg-line-2" />
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                }}
                                className=" parent-width mb-s pb-m pt-s"
                            >
                                <div className="ml-l">
                                    <div
                                        className="row pt-xl cursor-hand"
                                        onClick={() => {
                                            onCheckMarkChange("employee_details")
                                        }}
                                        style={{pointerEvents:"none"}}
                                    >
                                        <DKCheckMark disabled={true} isSelected={customField?.mappedWith.some(m => m === "employee_details")} color={getBgColor()} /><DKLabel className="ml-s" text={"Employee Details"} />
                                    </div>
                                    <div
                                        className="row pt-xl cursor-hand"
                                        style={{pointerEvents:isEdit ? "none":"initial" }}
                                        onClick={() => {
                                            if(isEdit) {
                                                return
                                            }
                                            onCheckMarkChange("payrun")
                                        }}
                                    >
                                        <DKCheckMark disabled={isEdit} isSelected={customField?.mappedWith.some(m => m === "payrun")} color={getBgColor()} /><DKLabel className="ml-s" text={"Payrun"} />
                                    </div>
                                    <div
                                        className="row pt-xl cursor-hand"
                                        style={{pointerEvents:isEdit ? "none":"initial" }}
                                        onClick={() => {
                                            if(isEdit) {
                                                return
                                            }
                                            onCheckMarkChange("payschedule")
                                        }}
                                    >
                                        <DKCheckMark disabled={isEdit} isSelected={customField?.mappedWith.some(m => m === "payschedule")} color={getBgColor()} /><DKLabel className="ml-s" text={"Payschedule"} />
                                    </div>
                                    <div
                                        className="row pt-xl cursor-hand"
                                        style={{pointerEvents:isEdit ? "none":"initial" }}
                                        onClick={() => {
                                            if(isEdit) {
                                                return
                                            }
                                            onCheckMarkChange("compOff")
                                        }}
                                    >
                                        <DKCheckMark disabled={isEdit} isSelected={customField?.mappedWith.some(m => m === "compOff")} color={getBgColor()} /><DKLabel className="ml-s" text={"Compensatory Off"} />
                                    </div>
                                </div>
                            </div>
                        </DKExpandableWrapper>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AddCustomFieldPopUp
